import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Article } from 'src/app/models/article';
import { DataServiceService } from 'src/app/services/data-service.service';
import { BannerSliderComponent } from '../banner-slider/banner-slider.component';
import { BannerCardComponent } from '../banner-card/banner-card.component';

@Component({
  selector: 'app-whats-new-articles',
  imports: [CommonModule, RouterModule, BannerSliderComponent, BannerCardComponent],
  templateUrl: './whats-new-articles.component.html',
  styleUrl: './whats-new-articles.component.scss'
})
export class WhatsNewArticlesComponent {

  articles = signal<Article[]>([]);

  constructor(private dataservice: DataServiceService) {
    this.dataservice.getArticle('&$top=8').subscribe(resp => {
      this.articles.set(resp.map(x => {
        // fallback to generic banner image for articles without a poster
        x.posterUrl = x.posterUrl
          ? x.posterUrl.replace('http://', 'https://').replace('177x100', '285x160').replace(/\.(png|jpg|jpeg)$/, '_q80.webp')
          : 'https://services.ifa.com/art/images/1640_512x288_c_ifc-generic-article-banner.png';
        return x;
      }));
    });
  }

}
